var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#248EDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7499 7.125C20.2816 7.125 22.3333 9.20833 22.3333 12.125C22.3333 17.9583 16.0833 21.2917 13.9999 22.5417C12.3524 21.5533 8.09742 19.2608 6.39075 15.4592L4.83325 15.4583V13.7917H5.84159C5.72825 13.2617 5.66659 12.7067 5.66659 12.125C5.66659 9.20833 7.74992 7.125 10.2499 7.125C11.7999 7.125 13.1666 7.95833 13.9999 8.79167C14.8333 7.95833 16.1999 7.125 17.7499 7.125ZM17.7499 8.79167C16.8533 8.79167 15.8833 9.26667 15.1783 9.97L13.9999 11.1483L12.8216 9.97C12.1166 9.26667 11.1466 8.79167 10.2499 8.79167C8.63325 8.79167 7.33325 10.1717 7.33325 12.125C7.33325 12.6958 7.40825 13.2517 7.55575 13.7917H9.36159L11.0833 10.9217L13.5833 15.0883L14.3616 13.7917H18.1666V15.4583H15.3049L13.5833 18.3283L11.0833 14.1617L10.3049 15.4583H8.25659C8.91492 16.6033 9.91075 17.6817 11.2041 18.7108C11.8249 19.2042 12.4874 19.665 13.2216 20.1275C13.4708 20.285 13.7174 20.4358 13.9999 20.6042C14.2824 20.4358 14.5291 20.285 14.7783 20.1283C15.5124 19.665 16.1749 19.2042 16.7949 18.7108C19.2791 16.7358 20.6666 14.5775 20.6666 12.125C20.6666 10.1583 19.3858 8.79167 17.7499 8.79167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.6906848b187e7bb5eb6c928c94b96078.svg";
export { ForwardRef as ReactComponent };